import darkTheme from '@mlb/react-patterns/components/Theme/themes/dark';

export const subnav = {
    height: '56px',
};

export const playbackPage = {
    padding: {
        top: '20px',
    },
    playlist: {
        width: '306px',
    },
};

export const filter = {
    width: '360px',
    columnGap: '24px',
};

export const pageTemplate = {
    paddingLeftRight: {
        xs: '14px',
        md: '16px',
        lg: '32px',
    },
};

const theme = {
    ...darkTheme,
    subnav,
    playbackPage,
    filter,
    pageTemplate,
};

export default theme;
